export enum PrescriptionType {
	HVLP = 'hvlp',
	IPLP = 'iplp',
}
